import * as React from 'react';
import { st, classes } from './WeeklyLeftSideTime.st.css';
import getLeftSideTimes from '../../../utils/getLeftSideTimes';
var WeeklyLeftSideTime = function (_a) {
    var is24format = _a.is24format, time = _a.time, isMobile = _a.isMobile, isResponsive = _a.isResponsive;
    var timeToRender = getLeftSideTimes(time.text, is24format, isResponsive);
    return (React.createElement("div", { id: "timeLineText", className: st(classes.TimeLineText, { isMobile: isMobile }) }, timeToRender));
};
export default WeeklyLeftSideTime;
//# sourceMappingURL=WeeklyLeftSideTime.js.map